module.exports = __webpack_public_path__ + "img/audi-event1.9aa7b9c0.jpg";